$(document).on "turbolinks:load", ->
  $("[data-toggle='modal']").click ->
    $("#" + $(this).data("modal-id")).toggleClass "is-active"
    $("body").toggleClass "is-clipped"
